/**
 * Channels API Endpoints
 * Centralized endpoint definitions for channels operations.
 */
export const CHANNELS_ENDPOINTS = {
  /**
   * Get all channels
   * @method GET
   * @endpoint /channels
   */
  CHANNELS: "/channels",

  /**
   * Get a specific channel by ID
   * @method GET
   * @endpoint /channels/{id}
   * @param {number} id - Channel ID
   */
  CHANNEL_BY_ID: (id: number) => `/channels/${id}`,

  /**
   * Get all running channels
   * @method GET
   * @endpoint /channels/running
   */
  RUNNING_CHANNELS: "/channels/running",

  /**
   * Get pending items count for a channel
   * @method GET
   * @endpoint /channels/{id}/pending
   * @param {number} id - Channel ID
   */
  CHANNEL_PENDING: (id: number) => `/channels/${id}/pending`,

  /**
   * Start or stop a channel
   * @method PUT
   * @endpoint /channels/{id}/is-running
   * @param {number} id - Channel ID
   * @query {boolean} newStatus - New running status
   */
  CHANNEL_STATUS: (id: number) => `/channels/${id}/is-running`,

  /**
   * Create a new channel.
   * @method POST
   * @endpoint /channels
   */
  CREATE_CHANNEL: "/channels",

  /**
   * Update an existing channel.
   * @method PUT
   * @endpoint /channels/{id}
   */
  UPDATE_CHANNEL: (id: number) => `/channels/${id}`,

  /**
   * Delete a channel.
   * @method DELETE
   * @endpoint /channels/{id}
   */
  DELETE_CHANNEL: (id: number) => `/channels/${id}`,
} as const;
